import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $dividendEvents,
  dividendEventsListMounted,
  getDividendEvents,
} from './model'
import { defaultFilterItems, FilterItems } from './types'

export const useDividendsList = () => {
  React.useEffect(() => {
    dividendEventsListMounted()
  }, [])

  const loading = useStore(getDividendEvents.pending)

  const dividends = useStore($dividendEvents)

  const filterItems = dividends.reduce((acc: FilterItems, val) => {
    if (!acc.propertyId.some((item) => item.value === val.propertyId)) {
      acc.propertyId.push({ value: val.propertyId, text: val.propertyId })
    }
    if (!acc.name.some((item) => item.value === val.name)) {
      acc.name.push({ value: val.name, text: val.name })
    }
    if (!acc.type.some((item) => item.value === val.type)) {
      acc.type.push({ value: val.type, text: val.type })
    }
    if (!acc.status.some((item) => item.value === val.status)) {
      acc.status.push({ value: val.status, text: val.status })
    }
    return acc
  }, defaultFilterItems)

  return { dividends, loading, filterItems }
}
